// import React from "react";

// Define the props interface
interface ButtonProps {
  label?: string; // Optional label text
  children?: React.ReactNode; // Optional children for custom content
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void; // onClick event handler
  className?: string; // Optional additional classes
  type?: "button" | "submit" | "reset"; // Optional button type
}

const Button: React.FC<ButtonProps> = ({
  label = "",
  children,
  onClick,
  className = "",
  type = "button",
}: ButtonProps) => {
  return (
    <button
      type={type}
      onClick={onClick}
      className={`bg-primary text-white px-3 py-3 rounded-md font-bold text-xl  hover:bg-white hover:text-primary hover:border-[#F8735F] border transition ${className}`}
    >
      {children || label}{" "}
      {/* Use `children` if provided, fallback to `label` */}
    </button>
  );
};

export default Button;
